/* Hopsydian — A Graceful Sin theme */
(function () {
  'use strict';
  var d = document;
  var root = (window.hx && window.hx.routes && window.hx.routes.root) || '/';
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };

  /* ---------- entry gate ---------- */
  var gate = $('#hx-gate');
  if (gate && !d.documentElement.classList.contains('gate-seen')) {
    d.body.classList.add('lock');
    var enter = $('[data-gate-enter]', gate);
    if (enter) setTimeout(function () { enter.focus(); }, 300);
    var closeGate = function () {
      try { sessionStorage.setItem('hx-gate', '1'); } catch (e) {}
      gate.classList.add('leaving');
      d.body.classList.remove('lock');
      setTimeout(function () { gate.remove(); }, 950);
    };
    if (enter) enter.addEventListener('click', closeGate);
    d.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Enter' && d.body.contains(gate)) { closeGate(); d.removeEventListener('keydown', onKey); }
    });
  }

  /* ---------- mobile menu ---------- */
  var mnav = $('#hx-mnav');
  var openBtn = $('[data-mnav-open]');
  function setMenu(open) {
    if (!mnav) return;
    mnav.classList.toggle('open', open);
    mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    d.body.classList.toggle('lock', open);
    if (open) { var c = $('[data-mnav-close]', mnav); if (c) c.focus(); } else if (openBtn) { openBtn.focus(); }
  }
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  $$('[data-mnav-close]').forEach(function (el) { el.addEventListener('click', function () { setMenu(false); }); });

  /* ---------- cart drawer ---------- */
  var cartEl = $('#hx-cart');
  var lastFocus = null;
  function setCount(n) { $$('.js-cart-count').forEach(function (el) { el.textContent = n; }); }
  function openCart() {
    if (!cartEl) return false;
    lastFocus = d.activeElement;
    setMenu(false);
    cartEl.classList.add('open');
    cartEl.setAttribute('aria-hidden', 'false');
    d.body.classList.add('lock');
    var c = $('[data-cart-close].label', cartEl); if (c) setTimeout(function () { c.focus(); }, 50);
    return true;
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.classList.remove('open');
    cartEl.setAttribute('aria-hidden', 'true');
    d.body.classList.remove('lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer(html) {
    if (!html || !cartEl) return;
    var tmp = d.createElement('div'); tmp.innerHTML = html;
    var fresh = $('#hx-cart', tmp);
    if (!fresh) return;
    var drawer = $('.drawer', cartEl), freshDrawer = $('.drawer', fresh);
    if (drawer && freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
    setCount(fresh.getAttribute('data-count') || '0');
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t && cartEl && !d.body.classList.contains('t-cart')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var q = e.target.closest('#hx-cart [data-line]');
    if (q) {
      e.preventDefault();
      var body = $('.drawer', cartEl); if (body) body.classList.add('busy');
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(q.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(q.getAttribute('data-set'), 10)), sections: ['hx-cart-drawer'] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.sections) renderDrawer(res.sections['hx-cart-drawer']);
      }).catch(function () { location.href = root + 'cart'; }).finally(function () {
        var b = $('.drawer', cartEl); if (b) b.classList.remove('busy');
      });
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); setMenu(false); closeFilm(); }
  });

  /* ---------- product page ---------- */
  $$('[data-product-root]').forEach(function (rootEl) {
    var jsonEl = $('[data-product-json]', rootEl);
    var form = $('form[data-product-form]', rootEl);
    if (!jsonEl || !form) return;
    var product = JSON.parse(jsonEl.textContent);
    var input = $('[data-variant-input]', form);
    var addBtn = $('[data-add]', form);
    var addLabel = $('[data-add-label]', form);
    var priceEl = $('[data-price]', rootEl);
    var msg = $('[data-msg]', form);
    var qtyInput = $('input[name="quantity"]', form);
    var pricesEl = $('[data-variant-prices]', rootEl);
    var prices = pricesEl ? JSON.parse(pricesEl.textContent) : {};
    var money = function (v) { return prices[String(v.id)] || ''; };
    var current = product.variants.filter(function (v) { return String(v.id) === input.value; })[0] || product.variants[0];

    function selectedOptions() {
      return $$('[data-option-index]', form).map(function (grp) {
        var on = $('.size.on', grp); return on ? on.getAttribute('data-value') : null;
      });
    }
    function refreshAvailability() {
      var groups = $$('[data-option-index]', form);
      var sel = selectedOptions();
      groups.forEach(function (grp, gi) {
        $$('.size', grp).forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var test = sel.slice(); test[gi] = val;
          var match = product.variants.filter(function (v) {
            return v.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          var avail = match.some(function (v) { return v.available; });
          btn.classList.toggle('out', !avail);
          btn.setAttribute('aria-label', val + (avail ? '' : ' — sold out'));
        });
      });
    }
    function update(v) {
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return;
      }
      current = v;
      input.value = v.id;
      if (priceEl) priceEl.textContent = money(v);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart — ' + money(v) : 'Sold out';
      // jump gallery to variant image
      if (v.featured_media) {
        var slide = $('.slide[data-media-id="' + v.featured_media.id + '"]', rootEl);
        if (slide) showSlide(parseInt(slide.getAttribute('data-slide'), 10));
      }
      if (history.replaceState) {
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
      refreshAvailability();
    }
    $$('[data-option-index]', form).forEach(function (grp) {
      var label = $('[data-option-value]', grp);
      $$('.size', grp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.size', grp).forEach(function (b) { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('on'); btn.setAttribute('aria-checked', 'true');
          if (label) label.textContent = btn.getAttribute('data-value');
          var sel = selectedOptions();
          var v = product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
          if (msg) msg.textContent = '';
          update(v);
        });
      });
    });
    $$('[data-qty]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10);
        qtyInput.value = Math.min(20, Math.max(1, n));
        update(current);
      });
    });
    qtyInput.addEventListener('change', function () { update(current); });
    refreshAvailability();

    // gallery
    var slides = $$('.slide', rootEl), thumbs = $$('.thumb', rootEl);
    function showSlide(i) {
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-thumb'), 10)); }); });

    // size guide link opens its accordion
    $$('[data-open-details]', rootEl).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var det = d.getElementById(a.getAttribute('data-open-details'));
        if (det) { e.preventDefault(); det.open = true; det.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });

    // add to cart
    form.addEventListener('submit', function (e) {
      if (!cartEl) return;
      e.preventDefault();
      addBtn.classList.add('is-loading');
      var fd = new FormData(form);
      fd.append('sections', 'hx-cart-drawer');
      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (msg) msg.textContent = res.j.status == 422 ? 'No more copies available.' : 'Could not add to cart.'; return; }
          if (res.j.sections) renderDrawer(res.j.sections['hx-cart-drawer']);
          openCart();
        })
        .catch(function () { form.submit(); })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });
  });

  /* ---------- film pop-up (YouTube, privacy-enhanced) ---------- */
  var modal = $('#hx-film-modal');
  function ytId(url) {
    var m = String(url).match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
    return m ? m[1] : null;
  }
  function closeFilm() {
    if (!modal || !modal.classList.contains('open')) return;
    modal.classList.remove('open'); $('.box', modal).innerHTML = ''; d.body.classList.remove('lock');
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-film]');
    if (a && modal) {
      var id = ytId(a.getAttribute('data-film'));
      if (!id) return;
      e.preventDefault();
      $('.box', modal).innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      modal.classList.add('open'); d.body.classList.add('lock');
      var x = $('[data-film-close]', modal); if (x) x.focus();
    }
    if (e.target.closest('[data-film-close]') || e.target === modal) closeFilm();
  });
})();
